@if (solution != null) {
	<ion-item lines="full" color="medium">
		<ion-icon aria-hidden="true" name="checkmark-done-outline" slot="start"></ion-icon>
		<ion-label (click)="solve()">
			{{ "INLINE_RESOLVE__SOLUTION" | transloco }}
			<p class="description">
				@if (solution.description !== "") {
					{{ solution.description }}
				} @else {
					<em>{{ "INLINE_RESOLVE__NO_DESCRIPTION" | transloco }}</em>
				}
			</p>
		</ion-label>
		<ion-icon slot="end" (click)="remove()" name="close-outline"></ion-icon>
	</ion-item>
} @else {
	<div class="button-container">
		<ion-button shape="round" fill="outline" color="primary" (click)="solve()">
			{{ "INLINE_RESOLVE__ADD_SOLUTION" | transloco }}
		</ion-button>
	</div>
}
